<template>
    <Chip class=" p-0 bg-grey mr-3">
        <div class="flex text-sm text-[#fff]">
            <img v-if="icon != null" id="icon" class="px-2 ml-0 mr-0 py-0.5 w-[2.3rem] bg-[#041e42] rounded-none"
                style="text-transform: capitalize" :src=icon :alt=props.type />
            <p v-else id="icon" class="px-2 mr-0 py-0.5 h-auto w-auto bg-[#041e42] rounded-none"
                style="text-transform: capitalize">{{ props.type }}</p>
            <span v-if="filterValue[nameKey]" class="px-2 py-0.5 bg-[#36a8dd] ">{{ filterValue[nameKey] }} </span>
            <span v-else class="px-2 py-0.5 bg-[#36a8dd] ">{{ filterValue[Object.keys(filterValue)[0]] }} </span>
            <button v-on:click="$emit('remove-tag')"
                class="pi pi-times-circle text-black text-md p-1 items-center"></button>
        </div>
    </Chip>
</template>

<script setup lang="ts">
import { defineProps, onMounted } from 'vue';
import Chip from 'primevue/chip';
import 'primeicons/primeicons.css';

const props = defineProps(['filterValue', 'nameKey', 'icon', 'index', 'type'])

</script>

<style>
.p-chip {
    border-radius: 0px;
}
</style>